const TStrings = {
    CURRENCY_TITLE: 'CURRENCY',
    PAYMENT_PROCESSOR_TITLE: 'PAYMENT PROCESSORS',
    AUTOMATIONS_TITLE: 'AUTOMATIONS',
    AUTOMATIONS_EMPTY:
        'Optionally set up automations whenever a payment is recorded.',
    SQUARE_DESCRIPTION: 'Accept payments via Square',
    STRIPE_DESCRIPTION:
        'Accept credit cards, Apple Pay, SEPA, and other payment types.',
    CONNECTED_BUTTON: 'Connected',
    NOT_CONNECTED_BUTTON: 'Not Connected',
    CONNECT_SQUARE_BUTTON: 'Connect to Square',
    MANAGE_SQUARE_BUTTON: 'Manage',
    CONNECT_STRIPE_BUTTON: 'Connect to Stripe',
    MANAGE_STRIPE_BUTTON: 'Manage',
    UNABLE_TO_RECEIVE_PAYMENTS:
        'Your account is unable to accept payments at this time',
    SQUARE_STEPS_REQUIRED:
        'Square setup is not complete. Please click "Manage" to finish setting up Square.',
    STRIPE_STEPS_REQUIRED:
        'There are still onboarding steps in Stripe to complete, please visit your Stripe dashboard to complete them.',
};

export default TStrings;
